<ion-row>
  <ion-col size="12">
    <div class="intro-title">
      <ion-label>{{content?.user?.components?.amoGuides?.componentTitle}}</ion-label>
    </div>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col size="6" size-xl="6" size-lg="6" size-md="12" size-sm="12" size-xs="12">
    <div>
      <ion-list class="guide-list">
        <ion-item lines="none">
          <ion-icon slot="start" src="../../../../../assets/svg/award.svg" class="guide-icons"></ion-icon>
          <ion-label class="ion-text-wrap">
            <p class="guide-titles">{{content?.user?.components?.amoGuides?.guideList?.step1?.title}}</p>
            <p class="guide-blurb">{{content?.user?.components?.amoGuides?.guideList?.step1?.content}} <span tappable
                class="link-highlight" (click)="openInformationModal('support')">Learn more.</span></p>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-icon slot="start" src="../../../../../assets/svg/hospital-user.svg" class="guide-icons"></ion-icon>
          <ion-label class="ion-text-wrap">
            <p class="guide-titles">{{content?.user?.components?.amoGuides?.guideList?.step2?.title}}</p>
            <p class="guide-blurb">{{content?.user?.components?.amoGuides?.guideList?.step2?.content}} <span tappable
                class="link-highlight" (click)="openInformationModal('predeparture')">Learn more.</span></p>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-icon slot="start" src="../../../../../assets/svg/users-class.svg" class="guide-icons"></ion-icon>
          <ion-label class="ion-text-wrap">
            <p class="guide-titles">{{content?.user?.components?.amoGuides?.guideList?.step3?.title}}</p>
            <p class="guide-blurb">{{content?.user?.components?.amoGuides?.guideList?.step3?.content}} <span tappable
                class="link-highlight" (click)="openInformationModal('orientation')">Learn more.</span></p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </ion-col>
  <ion-col size="6" size-xl="6" size-lg="6" size-md="12" size-sm="12" size-xs="12">
    <div>
      <ion-list class="guide-list">
        <ion-item lines="none">
          <ion-icon slot="start" src="../../../../../assets/svg/books-medical.svg" class="guide-icons"></ion-icon>
          <ion-label class="ion-text-wrap">
            <p class="guide-titles">{{content?.user?.components?.amoGuides?.guideList?.step4?.title}}</p>
            <p class="guide-blurb">{{content?.user?.components?.amoGuides?.guideList?.step4?.content}} <span tappable
                class="link-highlight" (click)="openInformationModal('resource')">Learn more.</span></p>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-icon slot="start" src="../../../../../assets/svg/atlas.svg" class="guide-icons"></ion-icon>
          <ion-label class="ion-text-wrap">
            <p class="guide-titles">{{content?.user?.components?.amoGuides?.guideList?.step5?.title}}</p>
            <p class="guide-blurb">{{content?.user?.components?.amoGuides?.guideList?.step5?.content}} <span tappable
                class="link-highlight" (click)="openInformationModal('additional')">Learn more.</span></p>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-icon slot="start" src="../../../../../assets/svg/file-contract.svg" class="guide-icons"></ion-icon>
          <ion-label class="ion-text-wrap">
            <p class="guide-titles">{{content?.user?.components?.amoGuides?.guideList?.step6?.title}}</p>
            <p class="guide-blurb">{{content?.user?.components?.amoGuides?.guideList?.step6?.content}} <span tappable
                class="link-highlight" (click)="openInformationModal('lor')">Learn more.</span></p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </ion-col>
</ion-row>